import { Switch } from "@shared/components/DataEntry";

import { useFeaturedDiscountSwitch } from "./controller";
import { FeaturedDiscountSwitchProps } from "./types";

export function FeaturedDiscountSwitch(props: FeaturedDiscountSwitchProps) {
  const { isFeatured, isPending, toggle } = useFeaturedDiscountSwitch(props);

  return (
    <Switch
      checked={isFeatured}
      onChange={toggle}
      disabled={isPending}
    />
  );
}
